var $0b4828edb010b855$exports = {};
$0b4828edb010b855$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `S\xe9lectionner un \xe9l\xe9ment`,
    "tableResizer": `Redimensionneur`
};


export {$0b4828edb010b855$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
